import React from "react";
import Category from "./shopBy/Category";
import Color from "./shopBy/Color";

/**
 * SEO-Optimized Sidebar for Shop Page
 * Includes product categories, colors, and space for brand & price filters
 * Designed for better UX, accessibility, and search engine indexing
 */
const ShopSideNav = () => {
  return (
    <aside
      className="w-full flex flex-col gap-6 p-4 bg-white shadow-md rounded-md"
      aria-label="Shop Filters and Categories"
    >
      {/* Shop by Product Categories */}
      <section aria-labelledby="shop-by-category">
        <h2
          id="shop-by-category"
          className="text-lg font-semibold text-primeColor mb-2"
        >
          Shop by Category
        </h2>
        <Category icons={true} /> {/* Icons enabled for better UX */}
      </section>

      {/* Shop by Color */}
      <section aria-labelledby="shop-by-color">
        <h2
          id="shop-by-color"
          className="text-lg font-semibold text-primeColor mb-2"
        >
          Shop by Color
        </h2>
        <Color />
      </section>

      {/* Placeholder for Future SEO-friendly Filters */}
      {/* 
      <section aria-labelledby="shop-by-brand">
        <h2
          id="shop-by-brand"
          className="text-lg font-semibold text-primeColor mb-2"
        >
          Shop by Brand
        </h2>
        <Brand />
      </section>

      <section aria-labelledby="shop-by-price">
        <h2
          id="shop-by-price"
          className="text-lg font-semibold text-primeColor mb-2"
        >
          Filter by Price
        </h2>
        <Price />
      </section>
      */}
    </aside>
  );
};

export default ShopSideNav;
